<div class="time-composition-container">
  <div class="time-composition-table-container">
    <div class="header">
      <div class="tab-icon">
        <h2>{{ TimeCompositionListLabels.HEADER_TEXT }}</h2>
        <emerald-icon
          [icon]="'open_in_new'"
          [color]="priority.grey"
          (click)="openTeamDetailsModal()"
        >
        </emerald-icon>
      </div>
      <div class="right-section">
        <div class="search-child">
          <emerald-input
            [label]="TimeCompositionListLabels.SEARCH"
            [trailingIcon]="'search'"
            (keyup)="searchTimeCompositionList($event)"
            [value]="filterValue"
            ><emerald-icon
              *ngIf="filterValue?.length && filterValue.length > 0"
              [icon]="'close'"
              (click)="clearInput()"
            ></emerald-icon>
          </emerald-input>
        </div>
        <div class="select-container">
          <emerald-dropdown
            [outlined]="true"
            [id]="'single_select_location'"
            [label]="TimeCompositionListLabels.LOCATION"
            [options]="locationOptions"
            (onChange)="onLocationSelect($event)"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown>
        </div>
        <div class="select-container">
          <emerald-dropdown
            [outlined]="true"
            [id]="'single_select_resource_type'"
            [label]="TimeCompositionListLabels.RESOURCE_TYPE"
            [options]="resourceTypeOptions"
            (onChange)="onResourceTypeSelect($event)"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown>
        </div>
      </div>
    </div>

    <ng-container *ngIf="displayData?.length; else noDataTemplate">
      <div class="tc-table-wrap">
        <table class="tc-table">
          <thead>
            <tr>
              <th class="sortable" (click)="setSort('name')">
                Resource <span class="sort-ind" *ngIf="sortField === 'name'">{{ sortDir === 1 ? '↑' : '↓' }}</span>
              </th>
              <th class="sortable" (click)="setSort('employeeType')">
                Type <span class="sort-ind" *ngIf="sortField === 'employeeType'">{{ sortDir === 1 ? '↑' : '↓' }}</span>
              </th>
              <th class="sortable" (click)="setSort('joiningDate')">
                Joining Date <span class="sort-ind" *ngIf="sortField === 'joiningDate'">{{ sortDir === 1 ? '↑' : '↓' }}</span>
              </th>
              <th class="sortable" (click)="setSort('location')">
                Location <span class="sort-ind" *ngIf="sortField === 'location'">{{ sortDir === 1 ? '↑' : '↓' }}</span>
              </th>
              <th class="th-action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of pagedData">
              <td>
                <div class="member-meta">
                  <div class="name">
                    <a (click)="openTeamDetailsModal(row.empId)"
                       title="Open Employee 360° view">{{ row.name }}</a>
                  </div>
                  <div class="title">{{ row.empId }} · {{ row.jobTitle }}</div>
                </div>
              </td>
              <td>
                <span class="type-chip"
                      [class.type-chip--emp]="row.employeeType === 'EMP'"
                      [class.type-chip--cwr]="row.employeeType !== 'EMP'">
                  {{ row.employeeType }}
                </span>
              </td>
              <td class="td-date">{{ row.joiningDate | date : 'd MMM y' }}</td>
              <td class="td-loc">{{ row.location | lowercase }}</td>
              <td class="td-action">
                <div class="action-group">
                  <!-- Slot 1: quarterly feedback exists for contractors only; EMP rows keep
                       the slot so Exclude / Mark Inactive line up across rows. -->
                  <button *ngIf="row.employeeType !== 'EMP'"
                          type="button"
                          class="action-btn"
                          (click)="onOpenContractorProfileModal(row.empId)">
                    {{ TimeCompositionListLabels.VIEW_ADD_FEEDBACK }}
                  </button>
                  <span *ngIf="row.employeeType === 'EMP'"
                        class="action-slot--empty"
                        title="Feedback applies to contractors (CWR) only">—</span>
                  <button type="button"
                          class="action-btn"
                          [title]="row.excludeFromIskill
                            ? 'Currently excluded from iSkill — click to include again'
                            : 'Hide this person from iSkill dashboards and reports'"
                          (click)="openExclusionDialog(row)">
                    {{ exclusionLabel(row) }}
                  </button>
                  <button type="button"
                          class="action-btn action-btn--danger"
                          title="Set status to InActive with a last working day"
                          (click)="openDeactivateDialog(row)">
                    {{ TimeCompositionListLabels.MARK_INACTIVE }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tc-footer">
          <span class="tc-count">
            Showing {{ pageStart + 1 }}–{{ pageEnd }} of {{ displayData.length }}
          </span>
          <div class="tc-pager">
            <button type="button" class="pager-btn" [disabled]="page === 1" (click)="prevPage()">‹ Prev</button>
            <span class="pager-page">{{ page }} / {{ totalPages }}</span>
            <button type="button" class="pager-btn" [disabled]="page >= totalPages" (click)="nextPage()">Next ›</button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noDataTemplate>
      <section class="records-container" aria-label="Records section">
        <div class="empty-state">
          <ng-container *ngIf="isDataLoaded && displayData?.length === 0">
            <h2 class="empty-state-title">
              {{ TimeCompositionListLabels.NO_RECORDS_FOUND }}
            </h2>
          </ng-container>
          <img
            [src]="imageSrc"
            alt="No records found"
            class="empty-state-image"
          />
        </div>
      </section>
    </ng-template>
  </div>
</div>

<app-modal-wrapper [showModal]="showContractorProfileModal">
  <app-contractor-profile
    *ngIf="showContractorProfileModal"
    [contractorId]="selectedContractorId!"
    [navigationSourceTeam]="'team-composition'"
    (close)="closeContractorProfileModal()"
  ></app-contractor-profile>
</app-modal-wrapper>

<app-confirmation-dialog
  [isOpen]="showExclusionDialog"
  [title]="exclusionDialogTitle"
  [message]="exclusionDialogMessage"
  [submitLabel]="actionRow?.excludeFromIskill
    ? TimeCompositionListLabels.INCLUDE_IN_ISKILL
    : TimeCompositionListLabels.EXCLUDE_FROM_ISKILL"
  [cancelLabel]="'Cancel'"
  [submitDisabled]="actionInProgress"
  (confirm)="confirmExclusion()"
  (cancel)="cancelAction()">
</app-confirmation-dialog>

<app-confirmation-dialog
  [isOpen]="showDeactivateDialog"
  [title]="TimeCompositionListLabels.MARK_INACTIVE_TITLE"
  [message]="deactivateDialogMessage"
  [submitLabel]="TimeCompositionListLabels.MARK_INACTIVE"
  [cancelLabel]="'Cancel'"
  [submitDisabled]="!lastWorkingDay || actionInProgress"
  (confirm)="confirmDeactivate()"
  (cancel)="cancelAction()">
  <div class="lwd-field">
    <label for="tc-lwd">{{ TimeCompositionListLabels.LAST_WORKING_DAY }} <span class="req">*</span></label>
    <input id="tc-lwd"
           type="date"
           name="lastWorkingDay"
           [(ngModel)]="lastWorkingDay"
           required />
    <small class="hint" *ngIf="!lastWorkingDay">Required to mark someone Inactive.</small>
  </div>
</app-confirmation-dialog>

<app-modal-wrapper [showModal]="showTeamDetailsModal">
  <app-team-composition-details
    *ngIf="showTeamDetailsModal"
    [empId]="selectedProfileId"
    (close)="closeTeamDetailsModal()"
  ></app-team-composition-details>
</app-modal-wrapper>
